import { QuillModule } from 'ngx-quill';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserMenuComponent } from './user-menu/user-menu.component';
import {
  MatMenuModule,
  MatButtonModule,
  MatPaginatorModule,
  MatAutocompleteModule,
  MatProgressBarModule
} from '@angular/material';
import { RouterModule } from '@angular/router';
import { CarrierApiService } from './services/carrier-api.service';
import { CoreModule } from '../core/core.module';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ClickAwayDirective } from './directives/click-away.directive';
import { FormsModule } from '@angular/forms';
import { ErrorHandlerService } from './services/error-handler.service';
import { FlashMessageService } from './services/flash-message.service';
import { HasEntitlementsDirective } from './directives/has-entitlements.directive';
import { ShipmentApiService } from './services/shipment-api.service';
import { PaginatorComponent } from './paginator/paginator.component';
import { InfiniteScrollDirective } from './infinite-scroll.directive';
import { CustomerSupportComponent } from './components/customer-support/customer-support.component';
import { SortingHeaderComponent } from './components/sorting-header/sorting-header.component';
import { LoadingSpinnerComponent } from './components/loading-spinner/loading-spinner.component';
import { AnnouncementsComponent } from './components/announcements/announcements.component';
import { HcComponentsModule } from '@hubgroup/hubconnect-ui-commons';
import { MaintenanceComponent } from './components/maintenance/maintenance.component';
import { SaveComponent } from './components/announcements/save/save.component';
import { ViewComponent } from './components/announcements/view/view.component';
import {ScrollingModule as ExperimentalScrollingModule} from '@angular/cdk-experimental/scrolling';
import { ScrollDispatchModule } from '@angular/cdk/scrolling';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { SafeHtmlPipe } from './pipes/safe-html/safe-html.pipe';
import { MaterialModule } from '../material.module';

@NgModule({
  declarations: [
    UserMenuComponent,
    ClickAwayDirective,
    HasEntitlementsDirective,
    PaginatorComponent,
    InfiniteScrollDirective,
    MaintenanceComponent,
    SortingHeaderComponent,
    LoadingSpinnerComponent,
    AnnouncementsComponent,
    SaveComponent,
    ViewComponent,
    SafeHtmlPipe
  ],
  exports: [
    UserMenuComponent,
    ClickAwayDirective,
    HasEntitlementsDirective,
    PaginatorComponent,
    InfiniteScrollDirective,
    SortingHeaderComponent,
    LoadingSpinnerComponent
  ],
  imports: [
    CommonModule,
    MatMenuModule,
    RouterModule,
    CoreModule,
    QuillModule,
    AngularSvgIconModule,
    HcComponentsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    ExperimentalScrollingModule,
    ScrollDispatchModule,
    FormsModule,
    MatPaginatorModule,
    MaterialModule
  ],
  providers: [
    CarrierApiService,
    ErrorHandlerService,
    FlashMessageService,
    ShipmentApiService
  ]
})
export class SharedModule { }
